import template from './employee_add_disciplinary.html';
import tr from '../../lib/default-translator.js';

class EmployeeAddDisciplinaryViewModel
{
    constructor(dialog) {
        this.dialog = dialog;
        this.name = ko.observable();
        this.valid_until = ko.observable();
        this.position = ko.observable();
        this.isExpired = ko.observable(false);
        this.employee_field_categories = ko.observableArray();
        this.employee_field_main_categories = ko.observableArray();
        this.access_roles = ko.observableArray();
        this.selectedRoles = ko.observableArray();
        this.start_date_picker = null;
        this.end_date_picker = null;
        this.start_time = ko.observable();
        this.time_delivered = ko.observable();
        this.place = ko.observable();
        this.type = ko.observable();
        this.note = ko.observable();
        this.status = ko.observable();
        this.disciplinary_id = ko.observable();
        this.employee_id = ko.observable();
        this.dialog_title = ko.observable();
    };


    format_title(title) {
        // Replace underscores with spaces and capitalize each word
        let formatted_title = title.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
        
        // Add # before any numbers
        formatted_title = formatted_title.replace(/(\d+)/g, '#$1');
        
        return formatted_title;
    }

    

    /*view_disciplinary()
    {
        //function to view the pdf for the enquiry 
         // 525
        let url = '/download/view_disciplinary/' + this.employee_id();
        window.open(url);
    }*/

    view_disciplinary() {
    const employeeId = this.employee_id();
    const additionalParam = {
        employee_id: this.employee_id(),
        name: this.name(),
        valid_until: this.valid_until(),
        position: this.position(),
        isExpired: this.isExpired(),
        employee_field_categories: this.employee_field_categories(),
        employee_field_main_categories: this.employee_field_main_categories(),
        access_roles: this.access_roles(),
        selectedRoles: this.selectedRoles(),
        start_time: this.start_time(),
        time_delivered: this.time_delivered(),
        place: this.place(),
        type: this.type(),
        note: this.note(),
        status: this.status(),
        disciplinary_id: this.disciplinary_id()
    };

    // Serialize the additional_param into a valid JSON string
    let serializedAdditionalParam = JSON.stringify(additionalParam);

    // Encode the serialized JSON string
    let encodedAdditionalParam = encodeURIComponent(serializedAdditionalParam);

    let url = '/download/view_disciplinary/' + employeeId + '?additional_param=' + encodedAdditionalParam;

    // Open the URL to view the PDF
    window.open(url);
}






    close()
    {
        this.dialog.close();
    }

    async initialize_datepickers()
    {
        let calendar_config = {
            enableTime: true,
            dateFormat: 'Y-m-d H:i',
            allowInput: true,
            time_24hr: true,
            onDayCreate: (dObj, dStr, fp, dayElem) => {
                let date_string = new Date(dayElem.dateObj.getTime() - (dayElem.dateObj.getTimezoneOffset() * 60000)).toISOString().split('T')[0];
            },
            appendTo: document.body,
            static: true,
        };

        this.start_date_picker = flatpickr('#datepicker_start', {
            ...calendar_config,
            defaultDate: this.start_time() || null
        });

        this.end_date_picker = flatpickr('#datepicker_end', {
            ...calendar_config,
            defaultDate: this.time_delivered() || null
        });
    }

};

class EmployeeAddDisciplinaryPage
{
    constructor(bindings)
    {
        this.viewModel = new EmployeeAddDisciplinaryViewModel(this);
        this.bindings = bindings;
        this.viewModel.employee_id(bindings.employee_id);


        console.log("this.bindings *************************");
        console.log(this.viewModel.employee_id());
    }

    async init()
    {
        this.viewModel.initialize_datepickers();
        try
        {
            if (this.bindings.title) 
                this.viewModel.dialog_title(this.viewModel.format_title(this.bindings.title));

            // Fetch employee details if employee_id is provided
            if (this.bindings.employee_id)
            {
                let options = {
                    table: 'v_all_employees_department',
                    schema: 'savanna',
                    limit: 1000000,
                    sortfield: 'employee_id',
                    sortorder: 'asc',
                    filter: [{
                        field: 'employee_id',
                        operator: '=',
                        value: this.bindings.employee_id
                    }]
                }
                let res_employee = await Grape.fetches.getJSON('/api/record', options);

                if (res_employee && res_employee.status === 'OK')
                {
                    this.viewModel.name(res_employee.records[0].firstname + res_employee.records[0].surname);    
                    this.viewModel.position(res_employee.records[0].position);    
                }
            }
            let options = {
                table: 'access_role',
                schema: 'grape',
                limit: 1000000,
                sortfield: 'role_name',
                sortorder: 'asc',
                filter: [{
                    value: ['guest', 'admin', 'manager', 'employee', 'accountant', 'general_manager', 'developer'],
                    op: 'IN',
                    field: 'role_name'
                }]
            };
    
            let res_role = await Grape.fetches.getJSON('/api/record', options);
            if (res_role)
                this.viewModel.access_roles(res_role.records);
        }
        catch (e)
        {
            console.error('Error in EmployeeAddFieldPage.init()', e);
        }
    };
};

export default {
    name: 'EmployeeAddDisciplinary',
    dialog_class: EmployeeAddDisciplinaryPage,
    template: template,
    template_filename: 'translation/dialogs/employee_add_disciplinary',
    provider: 'ps'
};